import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from '../../services/master-data.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-latest-reporting-partners-report',
  templateUrl: './latest-reporting-partners-report.component.html',
  styleUrls: ['./latest-reporting-partners-report.component.css']
})
export class LatestReportingPartnersReportComponent implements OnInit {

   selectedBranch;
  branchList;
  isBranchSelected = false;
  latestReportingPartnersReport;
  showExportToExcelButton: Boolean;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
  }

  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  onViewReport() {
    if (this.selectedBranch == null || this.selectedBranch.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select branch');
      return;
    }
    const branchIds = this.selectedBranch.map(branch => branch.id).join(',');

    this.masterDataService.getLatestReportingPartnersReport(branchIds).subscribe((res: any) => {
      console.log('latest reporting partners report', res);
      this.latestReportingPartnersReport = res;

      if (this.latestReportingPartnersReport == null) {
        this.commonMessageService.swalAlertWithoutIcon('', "No Record Found.");
        this.showExportToExcelButton = false;
      } else {
        this.showExportToExcelButton = true;
      }
    });
  }

  excelExportLatestReportingPartnersReport() {
      const branchIds = this.selectedBranch.map(branch => branch.id).join(',');
    this.masterDataService.getLatestReportingPartnersReportExcel(branchIds).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "Latest Reporting Partners Report.xlsx";
      link.click();
    });
  }

}
